import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import makeStyles from "@material-ui/core/styles/makeStyles";

import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import HubbleRefereeTable from "./HubbleRefereeTable";
import HubbleRequests from "services/hubble";
import { Box, Typography, Button } from "@material-ui/core";
import { Assessment } from "@material-ui/icons";
import { baseUrl } from "@jumbo/constants/baseUrl";
import axios from "../../../services/auth/jwt/config";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
  },
  searchBoxContainer: {
    paddingInline: "30px",
    paddingBlock: "16px",
    display: "flex",
    alignItems: "center",
  },
}));

const HubbleRefereeContainer = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { selectedJudge, hubbleRefereeTotalDocs } = useSelector(
    ({ hubble }) => hubble
  );

  useEffect(() => {
    dispatch(HubbleRequests.getHubbleRefereeList(1, selectedJudge));
  }, [selectedJudge]);

  const getReport = async () => {
    const downloadUrl = `${baseUrl}hubbleReferee/report/Level1`;
    try {
      const response = await axios.get(downloadUrl, {
        responseType: "blob",
      });
      const contentDisposition = response.headers["content-disposition"];
      let filename = "default-filename.xlsx";
      if (contentDisposition) {
        const filenameRegex = /filename\*=UTF-8''([^;]+)/;
        const matches = filenameRegex.exec(contentDisposition);
        if (matches && matches[1]) {
          filename = decodeURIComponent(matches[1]);
        } else {
          const regularFilenameRegex = /filename="([^"]+)"/;
          const regularMatches = regularFilenameRegex.exec(contentDisposition);
          if (regularMatches && regularMatches[1]) {
            filename = regularMatches[1];
          }
        }
      }
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download the file", error);
    }
  };

  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardContent className={classes.cardContentRoot}>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          padding={"20px"}
        >
          <Box className={classes.searchBoxContainer}>
            <Typography>
              تعداد {hubbleRefereeTotalDocs} نتیجه یافت شد.
            </Typography>
          </Box>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<Assessment />}
            onClick={getReport}
            style={{ marginRight: 14 }}
          >
            دریافت گزارش
          </Button>
        </Box>

        <HubbleRefereeTable />
      </CmtCardContent>
    </CmtCard>
  );
};

export default HubbleRefereeContainer;
